import * as React from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { ROUTES } from '@/configs/routes';

export const useIsDocumentsRoot = (): boolean => {
  const { pathname } = useLocation();

  return React.useMemo(
    () => Boolean(matchPath({ path: ROUTES.organization.documents.path, end: true }, pathname)),
    [pathname],
  );
};

export default useIsDocumentsRoot;
